<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
            div.pull-right.m-t-sm
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="onLoading('save-tag')",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green(
                    :disabled="onLoading('save-tag')",
                    @click="submit",
                )
                    v-loading(loader="save-tag") Create

            nav(aria-label="breadcrumb")
                ol.breadcrumb.white.m-b-0.p-b-0
                    li.breadcrumb-item
                        router-link(to="/") Tags
                    li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New Tag
            .box-divider.m-a-0
            .box-body
                include tag-form
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    computed: {
        ...mapGetters('tag', ['tag']),
    },

    created() {
        this.setTagAttribute({ key: 'name', value: null });
        this.setTagAttribute({ key: 'parent_id', value: null });
        this.setTagAttribute({ key: 'description', value: null });
    },

    methods: {
        ...mapActions('tag', ['setTagAttribute', 'createTag']),

        async submit() {
            const validate = await this.$validator.validate();
            if (!validate) return;

            try {
                await this.createTag();
                this.setTagAttribute({ key: 'name', value: null });
                this.setTagAttribute({ key: 'parent_id', value: null });
                this.setTagAttribute({ key: 'description', value: null });

                this.swal({ text: 'Tag successfully created' });
            } catch (e) {
                this.swalError({ text: e });
            }
        },
        cancel() {
            this.$router.push('/');
        },
        setParentTag(tagId) {
            this.setTagAttribute({ key: 'parent_id', value: tagId });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/tag/tag-create.vue